import React, {Component} from "react";
import {isDatabaseActive, openDatabase} from "./services/database/database";
import BaseApp from "./utils/baseApp";
import SystemConfigurationAccess from "./services/database/systemConfigurationAccess";
import SystemLogAccess from "./services/database/systemLogAccess";
import {systemConfigurationTable, systemLogTable} from "./config.json";
import Mobile1 from "./components/mobile1";
// import TimePeriods from "./components/timePeriods";
// import TimePeriodForm from "./components/timePeriodForm";
// import Movies from "./components/movies";
// import Customers from "./components/customers";
// import NavBar from "./components/navBar";
// import LoginForm from "./components/loginForm";
// import RegisterForm from "./components/registerForm";
import {toast, ToastContainer} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";

class App extends Component {
    constructor() {
        super();

        this.baseApp = new BaseApp();
        // this.baseApp.logProperties();

        this.rootLink = null;
        this.standardComponent = null; //{ Customers };
        this.componentState = {};
        // TODO
        // this.validateIfLoggedIn();

        /////////////////
        // Testumgebung fuer neue universelle mobile Erfassung
        this.standardComponent = null; //{ Mobile };
        /////////////////
    }

    state = {
        username: "",
        person: {},
        menus: [],
        database: null,
        configurations: {
            mandatoryNumber: "",
            deviceSerialNumber: "",
            defaultUsername: "",
            url: ""
        }
    };

    componentDidMount = async () => {
        const rawUrl = window.location.href.toString();
        const urlParameters =
            rawUrl.substring(rawUrl.indexOf("?") + 1)
                .split("&")
                .reduce(
                    (memo, param) => ({
                        ...memo,
                        [param.split("=")[0]]: param.split("=")[1]
                    }),
                    {}
                );

        // Alternative mittels lodash
        // import _ from "lodash";
        // const urlParsed2 = _.chain(window.location.href)
        //     .split('?')
        //     .nth(1)
        //     .split('&')
        //     .map(_.partial(_.split, _, '=', 2))
        //     .fromPairs()
        //     .value()
        // console.log("urlParsed2", urlParsed2);

        await this.initDatabase(urlParameters.mandatorNumber, urlParameters.deviceSerialNumber, urlParameters.defaultUsername);
    };

    initDatabase = async (urlMandatorNumber, urlDeviceSerialNumber, urlDefaultUsername) => {

        let database = null;
        if (isDatabaseActive()) {
            try {
                database = await openDatabase();
                if (database === null) {
                    toast.error("Fehler beim Anlegen der Daten (1)!");
                }
            } catch (ex) {
                toast.error("Fehler beim Anlegen der Daten (2)!");
            }
        } else {
            toast.error(
                "Lokales Speichern ist nicht möglich - wenn Daten nicht an den Server gesendet werden können, gehen diese Daten verloren!",
                {
                    autoClose: 30000
                }
            );
        }

        let mandatoryNumber = urlMandatorNumber ? urlMandatorNumber : "";
        let deviceSerialNumber = urlDeviceSerialNumber ? urlDeviceSerialNumber : "";
        let defaultUsername = urlDefaultUsername ? urlDefaultUsername : "";

        // Default-Records anlegen
        const mandatoryNumberRecord = await SystemConfigurationAccess.getByName(
            database,
            systemConfigurationTable,
            "mandatoryNumber"
        );
        if (mandatoryNumberRecord) {
            mandatoryNumber = mandatoryNumberRecord.value;
        } else {
            this.saveSystemConfiguration(database, "mandatoryNumber", mandatoryNumber);
        }

        const deviceSerialNumberRecord = await SystemConfigurationAccess.getByName(
            database,
            systemConfigurationTable,
            "deviceSerialNumber"
        );
        if (deviceSerialNumberRecord) {
            deviceSerialNumber = deviceSerialNumberRecord.value;
        } else {
            this.saveSystemConfiguration(database, "deviceSerialNumber", deviceSerialNumber);
        }

        const lastSynchronisationRecord = await SystemConfigurationAccess.getByName(
            database,
            systemLogTable,
            "lastSynchronisation"
        );
        if (!lastSynchronisationRecord) {
            this.saveSystemLog(database, "lastSynchronisation", "unknown");
        }

        const configurations = {
            mandatoryNumber: mandatoryNumber || "",
            deviceSerialNumber: deviceSerialNumber || "",
            defaultUsername: defaultUsername || ""
        };

        this.setState({database, configurations});
    };

    saveSystemConfiguration = async (database, name, value) => {
        try {
            if (database) {
                await SystemConfigurationAccess.add(
                    database,
                    systemConfigurationTable,
                    {
                        name: name,
                        value: value
                    }
                );
            } else {
                toast.error(
                    "Die Daten können lokal nicht gespeichert werden und gehen verloren (1)!",
                    {
                        autoClose: 15000
                    }
                );
            }
        } catch (ex) {
            toast.error(
                "Die Daten können lokal nicht gespeichert werden und gehen verloren (2)!",
                {
                    autoClose: 15000
                }
            );
        }
    };

    saveSystemLog = async (database, name, value) => {
        try {
            if (database) {
                await SystemLogAccess.add(database, systemLogTable, {
                    name: name,
                    value: value
                });
            } else {
                toast.error(
                    "Die Daten können lokal nicht gespeichert werden und gehen verloren (1)!",
                    {
                        autoClose: 15000
                    }
                );
            }
        } catch (ex) {
            toast.error(
                "Die Daten können lokal nicht gespeichert werden und gehen verloren (2)!",
                {
                    autoClose: 15000
                }
            );
        }
    };

    async validateIfLoggedIn() {
        const {data: userLoggedInData} = await this.baseApp.validateIfLoggedIn();
        if (!userLoggedInData || !userLoggedInData.username) {
            // login();
            // } else {
            this.setState({
                username: userLoggedInData.username,
                person: userLoggedInData.person,
                menus: userLoggedInData.menus
            });
        }
    }

    onSetConfigurations = configurations => {
        // console.log("App.onSetConfigurations(): configurations", configurations);
        this.setState({configurations});
    };

    render = () => {
        const {menus, person, database, configurations} = this.state;

        if (!database) {
            return <React.Fragment/>;
        }
        // console.log(
        //   "App.render(1): menus: ",
        //   menus,
        //   "this.rootLink: ",
        //   this.rootLink
        // );
        if (menus.length === 1 && person && person.id && person.id > 0) {
            this.rootLink = this.state.menus[0].link + `/${this.state.person.id}`;
        }
        // console.log(
        //   "App.render(2): menus: ",
        //   menus,
        //   "this.rootLink: ",
        //   this.rootLink
        // );

        // https://stackoverflow.com/questions/52681342/hide-url-extensions-using-react-router-dom

        // return (
        //   <BrowserRouter basename={this.baseApp.getBasename()}>
        //     <ToastContainer />
        //     <NavBar
        //       username={this.state.username}
        //       menus={this.state.menus}
        //       person={this.state.person}
        //     />
        //     <main className="container">
        //       <Switch>
        //         {/* https://stackoverflow.com/questions/42914666/react-router-external-link */}
        //         {/* <Route path="/login" target="http://localhost:8080/auth/login" /> */}
        //         {/* <Route
        //           path={["/login"]}
        //           component={props => {
        //             // window.location.replace(props.location.pathname.substr(1)); // substr(1) removes the preceding '/'
        //             window.location.replace("http://localhost:8080/auth/login"); // substr(1) removes the preceding '/'
        //             return null;
        //           }}
        //         /> */}
        //         <Route
        //           path="/timePeriods/:personId/:id"
        //           component={TimePeriodForm}
        //         />
        //         <Route path="/timePeriods/:personId" component={TimePeriods} />
        //         <Route path="/register" component={RegisterForm} />
        //         <Route path="/login" component={LoginForm} />
        //         {/* <Route path="/airports" render={() => (<div> This is the airport route </div>)}/> */}
        //         <Route path="/movies/:id" component={MovieForm} />
        //         <Route path="/movies" component={Movies} />
        //         <Route path="/customers" component={Customers} />
        //         <Route path="/rentals" component={Rentals} />
        //         <Route path="/not-found" component={NotFound} />
        //         {this.rootLink ? (
        //           <Redirect from="/" exact to={this.rootLink} />
        //         ) : (
        //           <Route path="/" component={Customers} />
        //         )}

        //         <Redirect to="/not-found" />
        //       </Switch>
        //     </main>
        //   </BrowserRouter>
        // );

        // console.log(
        //   "App.render(): this.baseApp.getBasename()=",
        //   this.baseApp.getBasename()
        // );

        // console.log("App.render(): this.rootLink=", this.rootLink);
        // return (
        //   <BrowserRouter basename={this.baseApp.getBasename()}>
        //     <ToastContainer />
        //     <Switch>
        //       <Route path="/mobile1">
        //         <Mobile1 database={database} />
        //       </Route>
        //       <Route path="/mobile2">
        //         <Mobile2 database={database} />
        //       </Route>
        //       <Route path="/rentals" component={Rentals} />
        //       <Route path="/not-found" component={NotFound} />
        //       {this.rootLink ? (
        //         <Redirect from="/" exact to={this.rootLink} />
        //       ) : (
        //         // <Route path="/" component={Mobile1} />
        //         <Route path="/">
        //           {/* <MovieForm /> */}
        //           <Mobile1 database={database} />
        //         </Route>
        //       )}

        //       <Redirect to="/not-found" />
        //     </Switch>
        //   </BrowserRouter>
        // );
        return (
            <React.Fragment>
                <ToastContainer/>
                <Mobile1
                    database={database}
                    configurations={configurations}
                    handleSetConfigurations={this.onSetConfigurations}
                />
            </React.Fragment>
        );
    }
}

export default App;
